<template>
  <div class="q-pa-sm">
    <task-queues
      :options="options"
      @select="onRowDblClick"
    />
  </div>
</template>

<script>
// Vuex
import { mapMutations } from 'vuex'

// Components
import TaskQueues from '../../components/queue/TaskQueues.vue'

export default {
  name: 'PickingTotesQueues',
  components: {
    TaskQueues
  },
  computed: {
    options () {
      return {
        settings: true,
        type: 'totes',
        title: 'Totes picking',
        service: this.$service.pickingQueue,
        adapters: ['totes']
      }
    }
  },
  methods: {
    ...mapMutations([
      'setPickingQueue'
    ]),
    onRowDblClick ({ item, toFilters }) {
      this.setPickingQueue(item)
      const path = `/workstation/queues/picking/entity/${item.id}${toFilters ? '?start=true' : ''}`
      this.$router.push(path)
    }
  }
}
</script>
